import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["newMlangVariantFromMasterLang", "moduleSchemaId"];
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ContentRoutes from 'ContentUtils/Routes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
// @ts-expect-error untyped selectors
import { getContent } from 'ContentEditorUI/redux/selectors/contentSchemaSelectors';
import { useQueryParams, useReplaceQueryParams } from 'ContentEditorUI/utils/routingUtils';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const NewMlangVariantFromMasterWarning = () => {
  const query = useQueryParams();
  // Since the query is a boolean, we need to verify it exists before JSON parsing it
  const isNewMlangVariantFromMasterLang = typeof query.newMlangVariantFromMasterLang === 'string' ? Boolean(JSON.parse(query.newMlangVariantFromMasterLang)) : false;
  const [isOpen, setIsOpen] = useState(isNewMlangVariantFromMasterLang);
  const replaceQueryParams = useReplaceQueryParams();
  const content = useSelector(getContent);
  const translatedFromId = content.translatedFromId;
  useEffect(() => {
    const params = _objectWithoutPropertiesLoose(query, _excluded);
    replaceQueryParams(params);
  }, [query, replaceQueryParams]);
  if (!isOpen || !translatedFromId) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newMlangVariantCreatedFromMasterLang.title"
    }),
    type: "warning",
    closeable: true,
    onClose: () => setIsOpen(false),
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "newMlangVariantCreatedFromMasterLang.body_jsx",
      options: {
        masterLangUrl: ContentRoutes.edit(translatedFromId, content.categoryId)
      },
      elements: {
        UILink: Link
      }
    })
  });
};
export default NewMlangVariantFromMasterWarning;